// @flow

import * as React from 'react';
import styled from 'styled-components';
import { colors, fontWeight } from 'seedling/constants';

type Flavor = 'lavender' | 'iris' | 'lightYellow' | 'poppy';

type Props = {
  flavor: Flavor,
  children: React.Node,
  className?: string,
};

export const FLAVORS = {
  lightYellow: {
    color: colors.darkestGrey,
    backgroundColor: colors.lightYellow,
    borderColor: colors.lightYellow,
  },
  poppy: {
    color: colors.darkestGrey,
    backgroundColor: colors.poppy,
    borderColor: colors.poppy,
  },
  iris: {
    color: colors.darkestGrey,
    backgroundColor: colors.iris,
    borderColor: colors.iris,
  },
  lavender: {
    color: colors.darkestGrey,
    backgroundColor: colors.lavender,
    borderColor: colors.lavender,
  },
};

function Tag({ flavor, children, className }: Props) {
  const flavorObject = FLAVORS[flavor];

  return (
    <TagImpl {...flavorObject} className={className}>
      {children}
    </TagImpl>
  );
}

Tag.displayName = 'Tag';

export default Tag;

/*
 * Tags are simple things that users can modify.
 */
const TagImpl = styled.div`
  font-size: 12px;
  ${fontWeight('normal')};
  border-radius: 24px;
  padding: 1px 10px;
  display: inline-block;
  vertical-align: middle;
  text-align: left;
  line-height: 1.45;

  color: ${props => props.color};
  background-color: ${props => props.backgroundColor};
  border: 1px solid ${props => props.borderColor};

  margin: 2px;

  &:first-letter {
    text-transform: capitalize;
  }
`;
